import { ReferralCodeCapture } from '@/components/generic';
import { CardAppProvider } from '@xhype/card-app-sdk';
import { useAutoLogout } from '@package/smart-wallet/hooks';
import {
  MagicProvider,
  SmartWalletProvider,
} from '@package/smart-wallet/providers';
import { config } from '@package/smart-wallet/utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';

import Routes from './pages';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 2 * 60 * 1000, // 2 minutes
    },
  },
});

function AppContent() {
  // Auto logout on JWT expiration (401 errors)
  useAutoLogout();

  return (
    <>
      <ReferralCodeCapture />
      <Routes />
    </>
  );
}

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <MagicProvider>
          <CardAppProvider
            cardAppApiKey={import.meta.env.VITE_CARD_APP_API_KEY}
            cardAppApiUrl={import.meta.env.VITE_CARD_APP_API_URL}
          >
            <SmartWalletProvider>
              <AppContent />
            </SmartWalletProvider>
          </CardAppProvider>
        </MagicProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
